import {IConfigurationEvaluationContext} from '../../configuration-evaluation-context/configuration-evaluation-context.interface';
import {ILogicalOperator} from './logical-operator.interface/logical-operator.interface';
import {ISegmentationRule} from '../segmentation-rule/segmentation-rule.interface';

export abstract class BaseLogicalOperator implements ILogicalOperator {

  constructor(private _rules: ISegmentationRule[]) {

  }

  get rules(): ISegmentationRule[] {
    return this._rules;
  }

  abstract evaluate(context: IConfigurationEvaluationContext): boolean;
}
